import { commonStyles } from '~/theme/styles/commonStyles.ts';
import { Box, Typography } from '@mui/material';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip.tsx';

export type TTooltipProps = {
  label: string;
  text: string;
};

export const TooltipInformer = ({ label, text }: TTooltipProps) => {
  return (
    <Box sx={{ ...commonStyles.centerFlexContainer, gap: 0.5 }}>
      <Typography variant="body2">{label}</Typography>
      <InfoTooltip title={text} iconStyles={() => ({ height: 19 })} />
    </Box>
  );
};
